module.exports = __webpack_public_path__ + "static/media/add_circle_blue.250c9b64.svg";